var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(_vm._s(_vm.calcUnit(_vm.value || 0))+_vm._s(_vm.conf && _vm.conf.bpmConfig && _vm.conf.bpmConfig.unit || ''))])}
var staticRenderFns = []

export { render, staticRenderFns }